"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
import type { Editor } from "@tiptap/react";
import { readChapterRecovery, writeChapterRecovery, clearChapterRecovery } from "@/lib/editor/chapter-recovery";

/** Recovery is offered explicitly so a local snapshot never replaces newer
 * server prose merely because the author returned through browser history. */
export function useChapterRecovery(chapterId, editor, initialContent) {
  const $ = _c(20);
  let t0;
  if ($[0] !== chapterId || $[1] !== initialContent) {
    t0 = () => readChapterRecovery(chapterId, initialContent);
    $[0] = chapterId;
    $[1] = initialContent;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [recovery, setRecovery] = useState(t0);
  const [recoveryUnavailable, setRecoveryUnavailable] = useState(false);
  let t1;
  if ($[3] !== chapterId) {
    t1 = content => {
      setRecoveryUnavailable(!writeChapterRecovery(chapterId, content));
    };
    $[3] = chapterId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const recordRecovery = t1;
  let t2;
  if ($[5] !== chapterId) {
    t2 = content_0 => {
      clearChapterRecovery(chapterId, content_0);
      setRecoveryUnavailable(false);
    };
    $[5] = chapterId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const acknowledgeSaved = t2;
  let t3;
  if ($[7] !== editor || $[8] !== recovery) {
    t3 = () => {
      if (!recovery || !editor || editor.isDestroyed) {
        return;
      }
      editor.commands.setContent(recovery);
      setRecovery(null);
    };
    $[7] = editor;
    $[8] = recovery;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const restoreRecovery = t3;
  let t4;
  if ($[10] !== chapterId || $[11] !== recovery) {
    t4 = () => {
      if (recovery) {
        clearChapterRecovery(chapterId, recovery);
      }
      setRecovery(null);
    };
    $[10] = chapterId;
    $[11] = recovery;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const discardRecovery = t4;
  let t5;
  if ($[13] !== acknowledgeSaved || $[14] !== discardRecovery || $[15] !== recordRecovery || $[16] !== recovery || $[17] !== recoveryUnavailable || $[18] !== restoreRecovery) {
    t5 = {
      recovery,
      recoveryUnavailable,
      recordRecovery,
      acknowledgeSaved,
      restoreRecovery,
      discardRecovery
    };
    $[13] = acknowledgeSaved;
    $[14] = discardRecovery;
    $[15] = recordRecovery;
    $[16] = recovery;
    $[17] = recoveryUnavailable;
    $[18] = restoreRecovery;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}